export default {
  alert_invalid_list_id_warn: 'Lista seleccionada inválida'
}
